export const AVP_METERING_POINTS_FETCH =
  'MANUAL_ISSUING_AVP_METERING_POINTS_FETCH';
export const RECALCULATE_GO = 'MANUAL_ISSUING_RECALCULATE_GO';
